const body = ['Basier Circle', 'Arial', 'Helvetica', 'sans-serif'];

const fontFamily = { body };

module.exports = { fontFamily };
